export default __webpack_public_path__ + "images/arc-thumbnail.jpg";